<template>
  <div>
    <div class="text-md-right">
    <a-button
      type="primary"
      icon="file-protect"
      style="margin-left:5px"
      @click="handleFinalBulkReport"
      size="small"
      :disabled= 'this.sectionId === 0 ? true : false'
    >
      Bulk Report Card
    </a-button>
    </div>
    <br />
  <div
    v-if="Object.keys(getSelectedStudentExamDetails).length!== 0"
    class="position-relative"
    id="finalResultReport"
  >
    <neo-print-wrapper
      title="Final Exam Report"
      style="margin-bottom: 80px"
    >
      <div class="row align-items-end">
        <div class="col-md-8" style="font-size:13px">
          <!-- <h1>{{selected_data.length}}</h1> -->
          <h6 class="font-weight-bold mb-0">
            {{getStudentDetails(studentIds).first_name}} &nbsp; {{getStudentDetails(studentIds).last_name}}
          </h6>
          <p class="mb-2">
            ID:
            <span class="font-weight-bold">
              {{getStudentDetails(studentIds).student_code}}
            </span>
            | Class:
            <span class="font-weight-bold">
              {{getStudentDetails(studentIds).enrollment[0].school_class.name}}
            </span>
            | Section:
            <span class="font-weight-bold">
              {{getStudentDetails(studentIds).enrollment[0].section.name}}
            </span>
            | Roll No.:
            <span class="font-weight-bold">
              {{getStudentDetails(studentIds).enrollment[0].roll_no}}
            </span>
            | Session:
            <span class="font-weight-bold">
              {{getStudentDetails(studentIds).enrollment[0].session.name}}
            </span>
          </p>
        </div>
        <div class="col-md-4 text-right">
          <!-- Session:
          <span class="font-weight-bold">
            2021
            {{ data.session.name }}
          </span> -->
        </div>
      </div>
      <a-divider />
      <!-- Class-I to Class-X -->
      <div class="mt-3" v-if="getReportFormat === 0">
        <vue-custom-scrollbar class="scroll-area">
          <table class="table table-bordered table-sm" style="font-size:12px">
            <thead class="bg-light">
              <!-- Top Exam row -->
              <tr class="text-center">
                <th rowspan="2">Subjects</th>
                <th :colspan="4">X-Periodic Tests + Internal Mark Secured</th>
                <th>Y-1st & 2nd Term Test</th>
                <th style="width:14.28%" rowspan="2">Final Result (X + Y)/2</th>
              </tr>
              <!-- Exam name row -->
              <!-- if 0 exam -->
              <tr class="text-center" v-if='finalResults.class_section_exams.length === 0'>
                <th>
                  <span> 1st P/T</span>
                </th>
                <th>
                  <span> 2nd P/T</span>
                </th>
                <th>
                  <span> 1st T/T</span>
                </th>
                <th>
                  <span> Int.Assess </span>
                </th>
                <th>
                  <span> 2nd T/T</span>
                </th>
              </tr>
              <!-- if 1 exam -->
              <tr class="text-center" v-if='finalResults.class_section_exams.length === 1'>
                <th v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                  <span>{{exams.exam.name}}</span>
                </th>
                <th>
                  <span> 2nd P/T</span>
                </th>
                <th>
                  <span> 1st T/T</span>
                </th>
                <th>
                  <span> Int.Assess </span>
                </th>
                <th>
                  <span> 2nd T/T</span>
                </th>
              </tr>
              <!-- if 2 exam -->
              <tr class="text-center" v-if='finalResults.class_section_exams.length === 2'>
                <th v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                  <span>{{exams.exam.name}}</span>
                </th>
                <!-- <th>
                  <span> 2nd P/T</span>
                </th> -->
                <th>
                  <span> 1st T/T</span>
                </th>
                <th>
                  <span> Int.Assess </span>
                </th>
                <th>
                  <span> 2nd T/T</span>
                </th>
              </tr>
              <!-- if 3 exam -->
              <tr class="text-center" v-if='finalResults.class_section_exams.length === 3'>
                <th v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                  <span>{{exams.exam.name}}</span>
                </th>
                <th>
                  <span> Int.Assess </span>
                </th>
                <th>
                  <span> 2nd T/T</span>
                </th>
              </tr>
              <!-- if 4 exam -->
              <tr class="text-center" v-if='finalResults.class_section_exams.length === 4'>
                <th v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                  <span>{{exams.exam.name}}</span>
                </th>
                <th>
                  <span> 2nd T/T</span>
                </th>
              </tr>
              <!-- if 5 exam -->
              <tr class="text-center" v-if='finalResults.class_section_exams.length === 5'>
                <th v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                  <span>{{exams.exam.name}}</span>
                </th>
              </tr>
              <!-- Full mark pass & Pass mark row -->
              <!-- if 0 exam -->
              <tr v-if='finalResults.class_section_exams.length === 0'>
                <template>
                  <th></th>
                  <th>F.M.:40 <br> P.M.:14</th>
                  <th>F.M.:40 <br> P.M.:14</th>
                  <th>F.M.:50 <br> P.M.:17</th>
                  <th>F.M.:50 <br> P.M.:17</th>
                </template>
                <template>
                  <th></th>
                </template>
              </tr>
              <!-- if 1 exam -->
              <tr v-if='finalResults.class_section_exams.length === 1'>
                <th style="width:14.28%"></th>
                <template>
                  <th style="width:14.28%" v-for="(fm,index) in finalResults.class_section_exams" :key="index">
                    <!-- F.M:{{fm.student_exam_marks[0].exam_full_mark}} <br> P.M.:{{fm.student_exam_marks[0].exam_pass_mark}} -->
                    F.M:{{getExamFullMark(fm.student_exam_marks)}} <br> P.M.:{{getExamPassMark(fm.student_exam_marks)}}
                  </th>
                  <th style="width:14.28%">F.M.:40 <br> P.M.:14</th>
                  <th style="width:14.28%">F.M.:50 <br> P.M.:17</th>
                  <th style="width:14.28%">F.M.:20 <br> P.M.:7</th>
                  <th style="width:14.28%">F.M.:50 <br> P.M.:17</th>
                </template>
                <template>
                  <th style="width:14.28%"></th>
                </template>
              </tr>
              <!-- if 2 exam -->
              <tr v-if='finalResults.class_section_exams.length === 2'>
                <template>
                  <th style="width:14.28%"></th>
                  <th style="width:14.28%" v-for="(fm,index) in finalResults.class_section_exams" :key="index">
                    F.M:{{getExamFullMark(fm.student_exam_marks)}} <br> P.M.:{{getExamPassMark(fm.student_exam_marks)}}
                  </th>
                  <th style="width:14.28%">F.M.:50 <br> P.M.:17</th>
                  <th style="width:14.28%">F.M.:20 <br> P.M.:7</th>
                  <th style="width:14.28%">F.M.:50 <br> P.M.:17</th>
                </template>
                <template>
                  <th style="width:14.28%"></th>
                </template>
              </tr>
              <!-- if 3 exam -->
              <tr v-if='finalResults.class_section_exams.length === 3'>
                <template>
                  <th style="width:14.28%"></th>
                  <th style="width:14.28%" v-for="(fm,index) in finalResults.class_section_exams" :key="index">
                    F.M:{{getExamFullMark(fm.student_exam_marks)}} <br> P.M.:{{getExamPassMark(fm.student_exam_marks)}}
                  </th>
                  <th style="width:14.28%">F.M.:20 <br> P.M.:7</th>
                  <th style="width:14.28%">F.M.:50 <br> P.M.:17</th>
                </template>
                <template>
                  <th style="width:14.28%"></th>
                </template>
              </tr>
              <!-- if 4 exam -->
              <tr v-if='finalResults.class_section_exams.length === 4'>
                <template>
                  <th style="width:14.28%"></th>
                  <th style="width:14.28%" v-for="(fm,index) in finalResults.class_section_exams" :key="index">
                    F.M:{{getExamFullMark(fm.student_exam_marks)}} <br> P.M.:{{getExamPassMark(fm.student_exam_marks)}}
                  </th>
                  <th style="width:14.28%">F.M.:50 <br> P.M.:17</th>
                </template>
                <template>
                  <th style="width:14.28%"></th>
                </template>
              </tr>
              <!-- if 5 exam -->
              <tr v-if='finalResults.class_section_exams.length === 5'>
                <template>
                  <th style="width:14.28%"></th>
                  <th style="width:14.28%" v-for="(fm,index) in finalResults.class_section_exams" :key="index">
                    F.M:{{getExamFullMark(fm.student_exam_marks)}} <br> P.M.:{{getExamPassMark(fm.student_exam_marks)}}
                  </th>
                </template>
                <template>
                  <th style="width:14.28%"></th>
                </template>
              </tr>
            </thead>
            <tbody>
              <!--  -->
              <tr v-for="(subjectData,index) in subjects" :key="index">
                <th>{{subjectData.name}}</th>
                <!-- 1 exam  -->
                <template v-if="finalResults.class_section_exams.length === 1">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectScoreMark(markData,subjectData.id)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>
                    {{getSubjectFinalScoreMark(finalResults.student_final_exam_marks[index],subjectData.id)}}
                  </td>
                </template>
                <!-- 2 exam  -->
                <template v-if="finalResults.class_section_exams.length === 2">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectScoreMark(markData,subjectData.id)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>
                    {{getSubjectFinalScoreMark(finalResults.student_final_exam_marks[index],subjectData.id)}}
                  </td>
                </template>
                <!-- 3 exam  -->
                <template v-if="finalResults.class_section_exams.length === 3">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectScoreMark(markData,subjectData.id)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>
                    {{getSubjectFinalScoreMark(finalResults.student_final_exam_marks[index],subjectData.id)}}
                  </td>
                </template>
                <!-- 4 exam  -->
                <template v-if="finalResults.class_section_exams.length === 4">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectScoreMark(markData,subjectData.id)}}
                  </td>
                  <td>NA</td>
                  <td>
                    {{getSubjectFinalScoreMark(finalResults.student_final_exam_marks[index],subjectData.id)}}
                  </td>
                </template>
                <!-- 5 exam  -->
                <template v-if="finalResults.class_section_exams.length === 5">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectScoreMark(markData,subjectData.id)}}
                  </td>
                  <td>
                    {{getSubjectFinalScoreMark(finalResults.student_final_exam_marks[index],subjectData.id)}}
                  </td>
                </template>
              </tr>
              <!-- Total Marks -->
              <tr>
                <th><B>Total</B></th>
                <!-- 1 exam  -->
                <template v-if="finalResults.class_section_exams.length === 1">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectTotalScoreMark(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 2 exam  -->
                <template v-if="finalResults.class_section_exams.length === 2">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectTotalScoreMark(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 3 exam  -->
                <template v-if="finalResults.class_section_exams.length === 3">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectTotalScoreMark(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 4 exam  -->
                <template v-if="finalResults.class_section_exams.length === 4">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectTotalScoreMark(markData)}}
                  </td>
                  <td>NA</td>
                </template>
                <!-- 5 exam  -->
                <template v-if="finalResults.class_section_exams.length === 5">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectTotalScoreMark(markData)}}
                  </td>
                </template>
                <th>
                    {{getFinalTotalScoreMark(finalResults.student_final_declared_marks)}}
                </th>
              </tr>
             <!-- get PC -->
              <tr>
                <th><B>Percentage</B></th>
                <!-- 1 exam  -->
                <template v-if="finalResults.class_section_exams.length === 1">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getPercentage(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 2 exam  -->
                <template v-if="finalResults.class_section_exams.length === 2">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getPercentage(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 3 exam  -->
                <template v-if="finalResults.class_section_exams.length === 3">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getPercentage(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 4 exam  -->
                <template v-if="finalResults.class_section_exams.length === 4">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getPercentage(markData)}}
                  </td>
                  <td>NA</td>
                </template>
                <!-- 5 exam  -->
                <template v-if="finalResults.class_section_exams.length === 5">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getPercentage(markData)}}
                  </td>
                </template>
                <th>
                    {{getFinalPc(finalResults.student_final_declared_marks)}}
                </th>
              </tr>
              <tr>
                <th><B>Rank / Div</B></th>
                <!-- 1 exam  -->
                <template v-if="finalResults.class_section_exams.length === 1">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getRankDiv(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 2 exam  -->
                <template v-if="finalResults.class_section_exams.length === 2">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getRankDiv(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 3 exam  -->
                <template v-if="finalResults.class_section_exams.length === 3">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getRankDiv(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 4 exam  -->
                <template v-if="finalResults.class_section_exams.length === 4">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getRankDiv(markData)}}
                  </td>
                  <td>NA</td>
                </template>
                <!-- 5 exam  -->
                <template v-if="finalResults.class_section_exams.length === 5">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getRankDiv(markData)}}
                  </td>
                </template>
                <th>{{getFinalRankDiv(finalResults.student_final_declared_marks)}}</th>
              </tr>
            </tbody>
          </table>
          <table class="table  table-sm">
              <tr style="font-size:10px">
                <th>Teacher's Remark</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
              <tr style="font-size:10px">
                <!-- if 1 exam -->
                <template v-if="finalResults.class_section_exams.length === 1">
                  <th style="width:25%" v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                    <span>{{exams.exam.name}}......................</span>
                  </th>
                  <th style="width:25%">2nd P/T......................</th>
                <th style="width:25%">1st T/T......................</th>
                <th style="width:25%">2nd T/T......................</th>
                </template>
                <!-- if 2 exam  -->
                <template v-if="finalResults.class_section_exams.length === 2">
                  <th style="width:25%" v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                    <span>{{exams.exam.name}}......................</span>
                  </th>
                <th style="width:25%">1st T/T......................</th>
                <th style="width:25%">2nd T/T......................</th>
                </template>
                <!-- if 3 exam  -->
                <template v-if="finalResults.class_section_exams.length === 3">
                  <th style="width:25%" v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                    <span>{{exams.exam.name}}......................</span>
                  </th>
                <th style="width:25%">2nd T/T......................</th>
                </template>
                <!-- if 4 exam  -->
                <template v-if="finalResults.class_section_exams.length === 4">
                  <th style="width:25%" v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                    <span>{{exams.exam.name}}......................</span>
                  </th>
                </template>
              </tr>
          </table>
          <table class="table  table-sm">
              <!-- Top Exam row -->
              <tr style="font-size:10px">
                <th style="width:33.33%">Teacher's signature</th>
                <th style="width:33.33%">Parent's signature</th>
                <th style="width:33.33%">Principal's signature</th>
              </tr>
          </table>
          <b style="font-size:11px"
            >N.B : Marks of final T/T is 100/2 = 50, so that we can calculate
            (X+Y) /2 as per board norm.</b
          >
        </vue-custom-scrollbar>
      </div>
      <!-- PRE-KG -->
      <div class="mt-3" v-if="getReportFormat === 1">
        <vue-custom-scrollbar class="scroll-area">
          <table class="table table-bordered table-sm" style="font-size:12px">
            <thead class="bg-light">
              <!-- Top Exam row -->
              <tr class="text-center">
                <th rowspan="2" style="width:16.16%">Subjects</th>
                <th :colspan="3">X-Periodic Tests + Internal Mark Secured</th>
                <th>Y-1st & 2nd Term Test</th>
                <th style="width:16.16%" rowspan="2">Final Result (X + Y)/2</th>
              </tr>
              <!-- Exam name row -->
              <!-- if 0 exam -->
              <tr class="text-center" v-if='finalResults.class_section_exams.length === 0'>
                <th style="width:16.16%">
                  <span> 1st P/T</span>
                </th>
                <th style="width:16.16%">
                  <span> 2nd P/T</span>
                </th>
                <th style="width:16.16%">
                  <span> 1st T/T</span>
                </th>
                <th style="width:16.16%">
                  <span> 2nd T/T</span>
                </th>
              </tr>
              <!-- if 1 exam -->
              <tr class="text-center" v-if='finalResults.class_section_exams.length === 1'>
                <th style="width:16.16%" v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                  <span>{{exams.exam.name}}</span>
                </th>
                <th style="width:16.16%">
                  <span> 2nd P/T</span>
                </th>
                <th style="width:16.16%">
                  <span> 1st T/T</span>
                </th>
                <th style="width:16.16%">
                  <span> 2nd T/T</span>
                </th>
              </tr>
              <!-- if 2 exam -->
              <tr class="text-center" v-if='finalResults.class_section_exams.length === 2'>
                <th style="width:16.16%" v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                  <span>{{exams.exam.name}}</span>
                </th>
                <!-- <th>
                  <span> 2nd P/T</span>
                </th> -->
                <th style="width:16.16%">
                  <span> 1st T/T</span>
                </th>
                <th style="width:16.16%">
                  <span> 2nd T/T</span>
                </th>
              </tr>
              <!-- if 3 exam -->
              <tr class="text-center" v-if='finalResults.class_section_exams.length === 3'>
                <th style="width:16.16%" v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                  <span>{{exams.exam.name}}</span>
                </th>
                <th style="width:16.16%">
                  <span> 2nd T/T</span>
                </th>
              </tr>
              <!-- if 4 exam -->
              <tr class="text-center" v-if='finalResults.class_section_exams.length === 4'>
                <th v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                  <span>{{exams.exam.name}}</span>
                </th>
              </tr>
              <!-- Full mark pass & Pass mark row -->
              <!-- if 0 exam -->
              <tr v-if='finalResults.class_section_exams.length === 0'>
                <template>
                  <th></th>
                  <th>F.M.:40 <br> P.M.:14</th>
                  <th>F.M.:40 <br> P.M.:14</th>
                  <th>F.M.:50 <br> P.M.:17</th>
                  <th>F.M.:50 <br> P.M.:17</th>
                </template>
                <template>
                  <th>F.M.:NA <br> P.M.:NA</th>
                </template>
              </tr>
              <!-- if 1 exam -->
              <tr v-if='finalResults.class_section_exams.length === 1'>
                <template>
                  <th style="width:14.28%"></th>
                  <th style="width:14.28%" v-for="(fm,index) in finalResults.class_section_exams" :key="index">
                    F.M:{{getExamFullMark(fm.student_exam_marks)}} <br> P.M.:{{getExamPassMark(fm.student_exam_marks)}}
                  </th>
                  <th style="width:14.28%" >F.M.:40 <br> P.M.:14</th>
                  <th style="width:14.28%">F.M.:50 <br> P.M.:17</th>
                  <th style="width:14.28%">F.M.:50 <br> P.M.:17</th>
                </template>
                <template>
                  <th style="width:14.28%"></th>
                </template>
              </tr>
              <!-- if 2 exam -->
              <tr v-if='finalResults.class_section_exams.length === 2'>
                <template>
                  <th style="width:14.28%"></th>
                  <th style="width:14.28%" v-for="(fm,index) in finalResults.class_section_exams" :key="index">
                    F.M:{{getExamFullMark(fm.student_exam_marks)}} <br> P.M.:{{getExamPassMark(fm.student_exam_marks)}}
                  </th>
                  <th style="width:14.28%">F.M.:50 <br> P.M.:17</th>
                  <th style="width:14.28%">F.M.:50 <br> P.M.:17</th>
                </template>
                <template>
                  <th style="width:14.28%"></th>
                </template>
              </tr>
              <!-- if 3 exam -->
              <tr v-if='finalResults.class_section_exams.length === 3'>
                <template>
                  <th style="width:14.28%"></th>
                  <th v-for="(fm,index) in finalResults.class_section_exams" :key="index">
                    F.M:{{getExamFullMark(fm.student_exam_marks)}} <br> P.M.:{{getExamPassMark(fm.student_exam_marks)}}
                  </th>
                  <th style="width:14.28%">F.M.:50 <br> P.M.:17</th>
                </template>
                <template>
                  <th style="width:14.28%"></th>
                </template>
              </tr>
              <!-- if 4 exam -->
              <tr v-if='finalResults.class_section_exams.length === 4'>
                <template>
                  <th style="width:14.28%"></th>
                  <th style="width:14.28%" v-for="(fm,index) in finalResults.class_section_exams" :key="index">
                    <!-- F.M:{{fm.student_exam_marks[0].exam_full_mark}} <br> P.M.:{{fm.student_exam_marks[0].exam_pass_mark}} -->
                    F.M:{{getExamFullMark(fm.student_exam_marks)}} <br> P.M.:{{getExamPassMark(fm.student_exam_marks)}}
                  </th>
                </template>
                <template>
                  <th style="width:14.28%"></th>
                </template>
              </tr>
            </thead>
            <tbody>
              <!--  mark score  -->
              <tr v-for="(subjectData,index) in subjects" :key="index">
                <th>{{subjectData.name}}</th>
                <!-- 1 exam  -->
                <template v-if="finalResults.class_section_exams.length === 1">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    <!-- {{getSubjectScoreMark(markData[index],subjectData.id)}} -->
                    {{getSubjectScoreMark(markData,subjectData.id)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>
                    {{getSubjectFinalScoreMark(finalResults.student_final_exam_marks[index],subjectData.id)}}
                  </td>
                </template>
                <!-- 2 exam  -->
                <template v-if="finalResults.class_section_exams.length === 2">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectScoreMark(markData,subjectData.id)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>
                    {{getSubjectFinalScoreMark(finalResults.student_final_exam_marks[index],subjectData.id)}}
                  </td>
                </template>
                <!-- 3 exam  -->
                <template v-if="finalResults.class_section_exams.length === 3">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectScoreMark(markData,subjectData.id)}}
                  </td>
                  <td>NA</td>
                  <td>
                    {{getSubjectFinalScoreMark(finalResults.student_final_exam_marks[index],subjectData.id)}}
                  </td>
                </template>
                <!-- 4 exam  -->
                <template v-if="finalResults.class_section_exams.length === 4">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectScoreMark(markData,subjectData.id)}}
                  </td>
                  <td>
                    {{getSubjectFinalScoreMark(finalResults.student_final_exam_marks[index],subjectData.id)}}
                  </td>
                </template>
              </tr>
              <!-- Total Marks -->
              <tr>
                <th><B>Total</B></th>
                <!-- 1 exam  -->
                <template v-if="finalResults.class_section_exams.length === 1">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectTotalScoreMark(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 2 exam  -->
                <template v-if="finalResults.class_section_exams.length === 2">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectTotalScoreMark(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 3 exam  -->
                <template v-if="finalResults.class_section_exams.length === 3">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectTotalScoreMark(markData)}}
                  </td>
                  <td>NA</td>
                </template>
                <!-- 4 exam  -->
                <template v-if="finalResults.class_section_exams.length === 4">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getSubjectTotalScoreMark(markData)}}
                  </td>
                </template>
                <th>
                    {{getFinalTotalScoreMark(finalResults.student_final_declared_marks)}}
                </th>
              </tr>
             <!-- get PC -->
              <tr>
                <th><B>Percentage</B></th>
                <!-- 1 exam  -->
                <template v-if="finalResults.class_section_exams.length === 1">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getPercentage(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 2 exam  -->
                <template v-if="finalResults.class_section_exams.length === 2">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getPercentage(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 3 exam  -->
                <template v-if="finalResults.class_section_exams.length === 3">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getPercentage(markData)}}
                  </td>
                  <td>NA</td>
                </template>
                <!-- 4 exam  -->
                <template v-if="finalResults.class_section_exams.length === 4">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getPercentage(markData)}}
                  </td>
                </template>
                <th>
                    {{getFinalPc(finalResults.student_final_declared_marks)}}
                </th>
              </tr>
              <tr>
                <th><B>Rank / Div</B></th>
                <!-- 1 exam  -->
                <template v-if="finalResults.class_section_exams.length === 1">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getRankDiv(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 2 exam  -->
                <template v-if="finalResults.class_section_exams.length === 2">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getRankDiv(markData)}}
                  </td>
                  <td>NA</td>
                  <td>NA</td>
                </template>
                <!-- 3 exam  -->
                <template v-if="finalResults.class_section_exams.length === 3">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getRankDiv(markData)}}
                  </td>
                  <td>NA</td>
                </template>
                <!-- 4 exam  -->
                <template v-if="finalResults.class_section_exams.length === 4">
                  <td v-for="(markData,index) in finalResults.class_section_exams" :key="index">
                    {{getRankDiv(markData)}}
                  </td>
                </template>
                <th>{{getFinalRankDiv(finalResults.student_final_declared_marks)}}</th>
              </tr>
            </tbody>
          </table>
          <table class="table  table-sm">
              <tr style="font-size:10px">
                <th>Teacher's Remark</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
              <tr style="font-size:10px">
                <!-- if 1 exam -->
                <template v-if="finalResults.class_section_exams.length === 1">
                  <th style="width:25%" v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                    <span>{{exams.exam.name}}......................</span>
                  </th>
                  <th style="width:25%">2nd P/T......................</th>
                <th style="width:25%">1st T/T......................</th>
                <th style="width:25%">2nd T/T......................</th>
                </template>
                <!-- if 2 exam  -->
                <template v-if="finalResults.class_section_exams.length === 2">
                  <th style="width:25%" v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                    <span>{{exams.exam.name}}......................</span>
                  </th>
                <th style="width:25%">1st T/T......................</th>
                <th style="width:25%">2nd T/T......................</th>
                </template>
                <!-- if 3 exam  -->
                <template v-if="finalResults.class_section_exams.length === 3">
                  <th style="width:25%" v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                    <span>{{exams.exam.name}}......................</span>
                  </th>
                <th style="width:25%">2nd T/T......................</th>
                </template>
                <!-- if 4 exam  -->
                <template v-if="finalResults.class_section_exams.length === 4">
                  <th style="width:25%" v-for="(exams,index) in finalResults.class_section_exams" :key="index">
                    <span>{{exams.exam.name}}......................</span>
                  </th>
                </template>
              </tr>
          </table>
          <table class="table  table-sm">
              <!-- Top Exam row -->
              <tr style="font-size:10px">
                <th style="width:50%">Teacher's signature</th>
                <th style="width:50%">Principal's signature</th>
              </tr>
          </table>
          <b style="font-size:11px"
            >N.B : Marks of final T/T is 100/2 = 50, so that we can calculate
            (X+Y) /2 as per board norm.</b
          >
        </vue-custom-scrollbar>
      </div>
    </neo-print-wrapper>

    <!-- Print Button -->
    <div class="position-absolute neo-tr-5 d-print-none">
      <button
        type="button"
        class="btn btn-light btn-sm btn-with-addon"
        @click="print"
      >
        <span class="btn-addon">
          <i class="btn-addon-icon fe fe-printer" />
        </span>
        Print
      </button>
    </div>
  </div>
  <div v-else>
    <NoData text="No students seleted" />
  </div>
  </div>
</template>

<script>
import { find } from 'lodash'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import NeoPrintWrapper from '@/components/layout/Print/Default'
import NoData from '@/components/layout/NoData/index'
export default {
  props: ['data', 'sessionId', 'classId', 'sectionId', 'selectedStudent_Ids', 'getSelectedStudentExamDetails', 'classSubjects', 'reportFormat'],
  components: {
    vueCustomScrollbar,
    NeoPrintWrapper,
    NoData,
  },
  data: function() {
    return {
      details: [{ id: 1, name: 'kala' }, { id: 2, name: 'mala' }],
    }
  },
  computed: {
    allStudent: function() {
      return this.data
    },
    studentIds: function() {
      return this.selectedStudent_Ids
    },
    finalResults: function() {
      return this.getSelectedStudentExamDetails
    },
    getSessionId: function() {
      return this.sessionId
    },
    subjects: function() {
      return this.classSubjects
    },
    getReportFormat: function() {
      return this.reportFormat
    },
    getClassId: function () {
      return this.classId
    },
    getSectionId: function () {
      return this.sectionId
    },
  },
  // mounted: function() {
  // },
  methods: {
    getStudentDetails(studentId) {
      const studentDetails = find(this.allStudent, {
        id: studentId,
      })
      return studentDetails
    },
    getClassSubjects() {
      return this.subjects
    },
    // get Exam full mark
    getExamFullMark(marksArray) {
      var foundValue = marksArray.filter(obj => obj.exam_full_mark !== null)
      if (foundValue == null) {
        return 'NA'
      } else {
        return foundValue[0].exam_full_mark
      }
    },
    // get Pass Mark
    getExamPassMark(marksArray) {
      var foundValue = marksArray.filter(obj => obj.exam_pass_mark !== null)
      if (foundValue == null) {
        return 'NA'
      } else {
        return foundValue[0].exam_pass_mark
      }
    },
    // get subjects mark
    getSubjectScoreMark(marksArray, subjeectId) {
      var foundValue = marksArray.student_exam_marks.filter(obj => obj.subject_id === subjeectId)
      // return foundValue.length
      if (foundValue.length !== 0) {
        var newObj = Object.assign({}, ...foundValue)
        if (newObj.is_absent === 0) {
          // if exam_mark_score
          if (newObj.exam_mark_score !== null) {
            return newObj.exam_mark_score
          } else if (newObj.exam_mark_grade !== null) {
            return newObj.exam_mark_grade
          } else if (newObj.exam_mark_grade === null && newObj.exam_mark_score === null) {
            const absent = '--'
            return absent
          } else {
            const absent = '--'
            return absent
          }
        } else {
          const absent = 'AB'
          return absent
        }
      } else {
        const noDatafound = '--'
        return noDatafound
      }
    },
    // get Final  mark
    getSubjectFinalScoreMark(marksArray, subjeectId) {
      // var data = [marksArray]
      if (marksArray != null) {
        // return marksArray
        if (marksArray.is_absent === 0) {
        // if exam_mark_score
          if (marksArray.exam_mark_score !== null) {
            return marksArray.exam_mark_score
          } else if (marksArray.exam_mark_grade !== null) {
            return marksArray.exam_mark_grade
          } else if (marksArray.exam_mark_grade === null && marksArray.exam_mark_score === null) {
            const absent = '--'
            return absent
          } else {
            const absent = '--'
            return absent
          }
        } else {
          const absent = 'AB'
          return absent
        }
      } else {
        const noDatafound = '--'
        return noDatafound
      }
    },
    // get total mark
    getSubjectTotalScoreMark(marksArray) {
      const totalScore = marksArray.student_declared_marks[0].total_mark_score
      const totalFullMark = marksArray.student_declared_marks[0].total_exam_full_mark
      return totalScore + '/' + totalFullMark
    },
    // get final total mark
    getFinalTotalScoreMark(marksArray) {
      var newObj = Object.assign({}, ...marksArray)
      const totalScore = newObj.total_mark_score
      const totalFullMark = newObj.total_exam_full_mark
      return totalScore + '/' + totalFullMark
    },
    // get final pc
    getFinalPc(marksArray) {
      var newObj = Object.assign({}, ...marksArray)
      const pc = newObj.mark_percentage
      return pc + '%'
    },
    // get PC
    getPercentage(marksArray) {
      const pc = marksArray.student_declared_marks[0].mark_percentage
      if (pc !== null) {
        return pc + '%'
      } else {
        return '--'
      }
    },
    // get final rank/div
    getFinalRankDiv(marksArray) {
      var newObj = Object.assign({}, ...marksArray)
      if (newObj.class_rank !== null) {
        return newObj.class_rank
      } else if (newObj.division !== null) {
        return newObj.division
      } else if (newObj.class_rank === null && newObj.division === null) {
        return 'Failed'
      } else {
        return 'Na'
      }
    },
    // get Rank/Div
    getRankDiv(marksArray) {
      const rank = marksArray.student_declared_marks[0].rank
      const div = marksArray.student_declared_marks[0].division
      if (rank !== null) {
        return rank
      } else if (div !== null) {
        return div
      } else if (rank === null && div === null) {
        return 'Failed'
      }
    },
    // bulk final report card
    handleFinalBulkReport() {
      // this.$router.push({ name: 'finalbulkReportCard' })
      this.$router.push({
        name: 'finalbulkReportCard',
        params: {
          classId: this.getClassId,
          sectionId: this.getSectionId,
          sessionId: this.getSessionId,
          reportformat: this.getReportFormat,
        },
      })
    },
    print() {
      this.$htmlToPaper('finalResultReport')
    },
  },
}
</script>
